import React, { useEffect, useState, useRef } from "react";
import Grid from "../../components/grid/ScannerGrid";
import { FlattenedObject, scanList, scanNgList } from "../../models/Po";
import { AppDispatch } from "../../redux/store";
import "./Scanner.css";
import { useDispatch } from "react-redux";
import { GridApi } from "ag-grid-enterprise";
import { fetchProcResult } from "../../redux/procSlice";
import RippleButton from "../ui/rippleButton";

// インターフェース
export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  rowData: FlattenedObject[];
  handlesetCheck: (changeId: scanList[]) => void;
}

const Scanner: React.FC<ModalProps> = (props) => {
  const dispatch: AppDispatch = useDispatch();
  const scanQrCode = useRef<string[]>([]); // 読み込んだコードを格納
  const scanOKList = useRef<scanList[]>([]); // 正常分
  const scanNGList = useRef<scanNgList[]>([]); // 異常分
  // 正常分(Grid表示用)
  const [scanOKGridList, setScanOKGridList] = useState<scanList[]>([]);
  // 異常分(Grid表示用)
  const [scanNGGridList, setScanNGGridList] = useState<scanNgList[]>([]);
  // 読込件数
  const scanReadCount = useRef<number>(0);
  // カメラストリーム
  const mediaStream = useRef<MediaStream | null>(null);
  // 読取完了ボタンdisable用（エラー確認チェック）
  const [isChecked, setIsChecked] = useState(false);
  // ビデオデバイスリスト
  //const videoDevices:MediaDeviceInfo[] = [];
  const [videoDevices, setVideoDevices] = useState<MediaDeviceInfo[]>([]);
  const [currentVideoDevice, setCurrentVideoDevice] =
    useState<MediaDeviceInfo>();
  const [videoWidth, setVideoWidth] = useState<number>(1280);
  const [videoHeight, setVideoHeight] = useState<number>(720);
  const [currentResolutionId, setCurrentResolutionId] = useState<string>("2");
  // 実際の解像度
  const [dispVideoWidth, setDispVideoWidth] = useState<number>(0);
  const [dispVideoHeight, setDispVideoHeight] = useState<number>(0);

  let interval: any;

  const resolutionList = [
    { id: "0", width: 0, height: 0, name: "デフォルト" },
    { id: "1", width: 640, height: 480, name: "480p" },
    { id: "2", width: 1280, height: 720, name: "720p" },
    { id: "3", width: 1920, height: 1080, name: "1080p" },
  ];
  // ビデオデバイスの取得
  useEffect(() => {
    if (!navigator.mediaDevices?.enumerateDevices) {
      console.log("enumerateDevices() not supported.");
    } else {
      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          const workVideoDevices = devices.filter(
            (d) => d.kind === "videoinput"
          );
          setVideoDevices(workVideoDevices);
          if (workVideoDevices.length > 0) {
            setCurrentVideoDevice(workVideoDevices[0]);
          }
          devices.forEach((device) => {
            console.log(
              `${device.kind}: ${device.label} id = ${device.deviceId}`
            );
          });
        })
        .catch((err) => {
          console.error(`${err.name}: ${err.message}`);
        });
    }

    return () => {
      // タイマーをクリア
      clearInterval(interval);
      // カメラストップ
      mediaStream.current?.getTracks().forEach((track) => track.stop());
      mediaStream.current = null;
    };
  }, []);


  const onGridReadyOK = (params: { api: GridApi }) => {
    //setOkGridApi(params.api);
    //params.api.sizeColumnsToFit();
  };

  const onGridReadyNG = (params: { api: GridApi }) => {
    //setNgGridApi(params.api);
    //params.api.sizeColumnsToFit();
  };

  const videoRef = useRef<HTMLVideoElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const cameraWidth = 1280; // 画面上のサイズはCSSで指定する（カメラから入力するサイズ）
  const cameraHeight = 720;

  // 読取完了ボタン押下時の処理
  const closeDisp = () => {
    // 正常の読込が1件以上ある場合、一覧のチェックボックスをつける
    if (scanOKGridList.length > 0) {
      props.handlesetCheck(scanOKGridList);
    }
    props.onClose(); // Controllerの閉じる機能を呼び出す。
  };

  const handledeleteId = (deleteScanCode: string) => {
    scanQrCode.current = scanQrCode.current.filter(
      (value) => value !== deleteScanCode
    );
    scanOKList.current = scanOKList.current.filter(
      (value) => value.po_desc_num !== deleteScanCode
    );
    setScanOKGridList([...scanOKList.current]);
  };

  const scanVideoFrame = async () => {
    // setIntervalで定期的に呼び出される関数
    // 100ms間隔で実行されるため、重たい処理は避けること

    try {
      const video = videoRef.current;
      if (!video || video.readyState < video.HAVE_ENOUGH_DATA) return;

      const canvas = canvasRef.current;
      if (!canvas) return;
      const ctx = canvas.getContext("2d", { willReadFrequently: true });
      if (!ctx) return;
      ctx.clearRect(0, 0, cameraWidth, cameraHeight);
      ctx.drawImage(video, 0, 0, cameraWidth, cameraHeight);
      const imgData = ctx.getImageData(0, 0, cameraWidth, cameraHeight);

      const symbols: any[] = await window.zbarWasm.scanImageData(
        imgData as unknown as ImageData
      );
      const decodedTexts: string[] = [];

      for (let i = 0; i < symbols.length; i++) {
        const symbol = symbols[i];

        // 読み取ったコードを取得
        const scanCode = symbol.decode();
        //console.log("Decoded Text:", scanCode);
        decodedTexts.push(scanCode);

        // 枠線の色を設定
        let strokeColor = "#F9C748"; // グリッドの一覧に反映されていないQRコードの色
        if (
          scanOKList.current.find((value) => value.po_desc_num === scanCode)
        ) {
          strokeColor = "#19FF19"; // 正常に読み込まれた一覧に反映されているQRコードの色
        } else if (
          scanNGList.current.find((value) => value.po_desc_num === scanCode)
        ) {
          strokeColor = "#FF3366"; // 異常に読み込まれた一覧に反映されているQRコードの色
        }

        // 四角を設定する際の初期化
        ctx.beginPath();
        // QRコードを線で囲む
        const lastPoint = symbol.points[symbol.points.length - 1];
        ctx.moveTo(lastPoint.x, lastPoint.y);
        symbol.points.forEach((point: { x: number; y: number }) =>
          ctx.lineTo(point.x, point.y)
        );
        // 囲み線の太さ
        ctx.lineWidth = Math.max(
          Math.min(canvas.height, canvas.width) / 100,
          1
        );
        // 囲み線の色
        ctx.strokeStyle = strokeColor;
        // 四角を描画
        ctx.stroke();
      }

      // 読み込んだQRコードを一覧に追加する
      let hasReadCode = false;
      for (let i = 0; i < decodedTexts.length; i++) {
        const value = decodedTexts[i];
        if (!scanQrCode.current.includes(value)) {
          // 読み込み済みのコードとして保存する
          scanQrCode.current.push(value);
          // 読み込んだQRコードを一覧に追加する
          await addScanCode(value);
          hasReadCode = true;
        }
      }

      if (hasReadCode) {
        // 読み込んだQRコードの件数を更新
        for (let i = 0; i < scanNGList.current.length; i++) {
          const value = scanNGList.current[i];
          value.totalcnt = scanReadCount.current;
        }
        setScanOKGridList([...scanOKList.current]); // 再描画するために新しい配列を作成
        setScanNGGridList([...scanNGList.current]); // 再描画するために新しい配列を作成
      }
    } catch (error) {
      console.error("Error scanning video frame:", error);
    }
  };

  const hasProcList = (QRData: string): scanList | null => {
    // 読み込んだQRコードが存在しているかをチェック
    // 一覧の受注Noと一致しているかを確認
    let rowData: FlattenedObject[] = props.rowData;
    for (let cnt = 0; cnt < rowData.length; cnt++) {
      if (rowData[cnt].po_desc_num === QRData) {
        const strarray: scanList = {};
        strarray.po_desc_num = rowData[cnt].po_desc_num; // 受注No
        strarray.destin_name = rowData[cnt].destin_name; // 送り先名
        strarray.customer_name = rowData[cnt].customer_name; // 得意先名
        strarray.product_name = rowData[cnt].product_name; // 商品名
        strarray.current_qty = rowData[cnt].current_qty; // 現計画数
        return strarray;
      }
    }
    return null;
  };

  const addScanCode = async (scanCode: string) => {
    if (!scanCode) return;
    scanReadCount.current = scanReadCount.current + 1;
    const scaninfo = hasProcList(scanCode);
    if (scaninfo) {
      // OKの場合
      scanOKList.current.push(scaninfo);
    } else {
      // NGの場合
      const strarray: scanNgList = {};
      strarray.po_desc_num = scanCode; // 受注No
      strarray.readNo = scanReadCount.current; // 読込番号
      strarray.totalcnt = scanReadCount.current; // 読込件数
      let ngdata = null;
      try {
        ngdata = await dispatch(fetchProcResult(scanCode));
      } catch (error) {
        console.error("Error fetching machine result:", error);
      }
      if (ngdata && ngdata.length > 0) {
        strarray.mach_name = ngdata[0].mach_name; // 機械名
        strarray.po_width = ngdata[0].po_width.toString(); // 受注寸法W
        strarray.po_height = ngdata[0].po_height.toString(); // 受注寸法H
        strarray.thickness = ngdata[0].thickness; // 板厚
        strarray.destin_name = ngdata[0].destin_name; // 送り先名
      }
      scanNGList.current.push(strarray);
    }
  };

  useEffect(() => {
    const constraints =
      currentResolutionId === "0"
        ? {
            video: {
              deviceId: currentVideoDevice?.deviceId,
            },
          }
        : {
            video: {
              //facingMode: 'user',
              deviceId: currentVideoDevice?.deviceId,
              width: { ideal: videoWidth },
              height: { ideal: videoHeight },
            },
          };

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        mediaStream.current = stream;
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
        const track = stream.getVideoTracks()[0];
        const settings = track.getSettings();
        if (
          settings !== undefined &&
          settings.width !== undefined &&
          settings.height !== undefined
        ) {
          setDispVideoWidth(settings.width);
          setDispVideoHeight(settings.height);
        }
      })
      .catch((err) => {
        console.error("An error occurred: " + err);
        alert(
          "An error occurred while trying to get the camera: " + err.message
        );
      });
    clearInterval(interval);
    // 定期的に画像を抽出するためのタイマー処理
    interval = setInterval(scanVideoFrame, 100);
  }, [currentVideoDevice, currentResolutionId]);

  const handleErrorCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(e.target.checked);
  };

  const handleDeviceChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    console.log(e.target.value);
    const selectDevice = videoDevices.filter(
      (d) => d.deviceId == e.target.value
    );
    setCurrentVideoDevice(selectDevice[0]);
  };
  const handleResolutionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    console.log(e.target.value);
    const resolution = resolutionList.filter((d) => d.id === e.target.value);
    setVideoWidth(resolution[0].width);
    setVideoHeight(resolution[0].height);
    setCurrentResolutionId(resolution[0].id);
  };
  console.log("scaner render");

  return (
    <div className="scanner-container">
      <div className="scanner-title-item">
        <p className="full-text text-center">Scanning...</p>
        <p className="normal-textCol text-center">スキャン中</p>
      </div>
      <div className="scanner-devicelist-item">
        <label htmlFor="scanner-devicelist-id">デバイス</label>
        <select
          id="scanner-devicelist-id"
          onChange={handleDeviceChange}
          value={currentVideoDevice?.deviceId}
          className=""
        >
          {videoDevices?.map(({ deviceId, label }) => (
            <option key={deviceId} value={deviceId}>{`${label}`}</option>
          ))}
        </select>

        <label htmlFor="scanner-resolution-id">解像度 </label>
        <select
          id="scanner-resolution-id"
          onChange={handleResolutionChange}
          value={currentResolutionId}
          className=""
        >
          {resolutionList?.map(({ id, name }) => (
            <option key={id} value={id}>{`${name}`}</option>
          ))}
        </select>
      </div>
      <div className="scanner-viewport-item">
        <div className="view-resolution">
          width:{dispVideoWidth} height:{dispVideoHeight}
        </div>

        <canvas
          id="canvas"
          ref={canvasRef}
          className="scanner-video"
          width={cameraWidth}
          height={cameraHeight}
        />
        <video
          id="video"
          ref={videoRef}
          autoPlay={true}
          className="scanner-video"
          width={cameraWidth}
          height={cameraHeight}
        />
      </div>

      <div className="scanner-result-list-item">
        <div>
          <p className="ok-textCol text-center">
            現在の読み取り件数:{scanReadCount.current}件
          </p>
          <p className="ok-textCol text-center">
            正常件数:
            <span className="ok-textCol read-Count">
              {scanOKGridList.length}
            </span>
            件
          </p>
          <div
            className={
              scanNGGridList.length <= 0
                ? "scanner-ok-grid-no-error"
                : "scanner-ok-grid-has-error"
            }
          >
            <Grid
              rowData={scanOKGridList}
              onGridReady={onGridReadyOK}
              handleDeleteRow={handledeleteId}
              isOkList={true}
            />
          </div>
        </div>
        {scanNGGridList.length > 0 && (
          <div>
            <p className="ok-textCol text-center">
              エラー件数:
              <span className="text-center error-textCol read-Count">
                {scanNGGridList.length}
              </span>
              件
            </p>
            <div className="scanner-ng-grid">
              <Grid
                rowData={scanNGGridList}
                onGridReady={onGridReadyNG}
                handleDeleteRow={handledeleteId}
                isOkList={false}
              />
            </div>
            <div className="text-center scanner-error-confirm ">
              <label>
                <input
                  type="checkbox"
                  id="check"
                  className="big"
                  checked={isChecked}
                  onChange={handleErrorCheck}
                />
                エラー確認
              </label>
            </div>
          </div>
        )}
      </div>

      <div className="scanner-button-item">
        {!isChecked && scanNGGridList.length > 0 ? (
          <div className="btn">
            <RippleButton
              width={"640px"}
              heihgt={"56px"}
              borderRadius={"8px"}
              textColor={"black"}
              effectSize={160}
              className="bk-darkgrey"
            >
              <span className="children">読取終了</span>
            </RippleButton>
          </div>
        ) : (
          <div className="btn">
            <RippleButton
              width={"640px"}
              heihgt={"56px"}
              borderRadius={"8px"}
              onClick={closeDisp}
              effectSize={160}
              className="bk-secondary"
            >
              <span className="children">読取終了</span>
            </RippleButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default Scanner;
